module.exports = __webpack_public_path__ + "static/media/cryocabin.f385ed97.png";